<template lang="pug">
.success-action-button(@click="handleClick")
  .go-cycle {{ buttonText }}
</template>

<script>
export default {
  name: 'SuccessActionButton',
  props: {
    // 按钮文案
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="less" scoped>
// 与 newClient sign-in-action 样式完全一致
.success-action-button {
  color: #08f;
  background-color: #e6f4ff;
  width: 2.67rem;
  height: 0.52rem;
  line-height: 0.52rem;
  font-size: 0.18rem;
  text-align: center;
  margin: 0 auto;
  border: 1px solid #08f;
  border-radius: 0.52rem;
  cursor: pointer;
}
</style>
